export interface EmailListResult {
  emails: string[]
  error: { key: 'empty' | 'invalid' | 'duplicate' | 'maximum'; index: number } | null
}

/** Same simple address rules as normalize_partner_email; never drop tokens. */
export function parseOnboardingEmails(input: string): EmailListResult {
  const tokens = input.split(',')
  if (tokens.length > 200) return { emails: [], error: { key: 'maximum', index: 0 } }
  const emails: string[] = []
  const seen = new Set<string>()
  for (const [index, token] of tokens.entries()) {
    const email = token.trim().toLowerCase()
    if (!email) return { emails: [], error: { key: 'empty', index: index + 1 } }
    const parts = email.split('@')
    const labels = parts[1]?.split('.') ?? []
    if (email.length > 254 || /\s/.test(email) || [...email].some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)
      || parts.length !== 2 || !parts[0] || labels.length < 2 || labels.some((label) => !label)) {
      return { emails: [], error: { key: 'invalid', index: index + 1 } }
    }
    if (seen.has(email)) return { emails: [], error: { key: 'duplicate', index: index + 1 } }
    seen.add(email)
    emails.push(email)
  }
  return { emails, error: null }
}
